<template>
  <div v-parallax-fit="parallax" class="social">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/27_SocialAction.png" alt="">
  </div>
</template>

<script>
export default {
  inject: ['helpers'],
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 21500,
          end: 22300,
          fromStyle: { transform: 'translateX(-33%) translateY(-300%) rotate(10deg)', marginTop: '0px' },
          toStyle: { transform: 'translateX(-55%) translateY(-50%) rotate(-5deg)', marginTop: '10px' },
          easing: 'linear'
        },
        {
          start: 22600,
          end: 23200,
          fromStyle: { transform: 'translateX(-55%) translateY(-50%) rotate(-5deg)', marginTop: '0px' },
          toStyle: { transform: 'translateX(-55%) translateY(250%) rotate(0deg)', marginTop: '0px' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/15.png',
          url: 'https://docs.google.com/document/d/e/2PACX-1vRKlB_cEzEGhf7poIB64lfghsHVG7HIXmdR9rJ4IS4FBlghZyYb17DONAybPw7WzVSOFtuK4yB-IF6b/pub',
          link_title: {
			'en': "Destructive Bellwether Manufactured Home Lending",
			'es': 'Préstamos destructivos de viviendas prefabricadas'
		  },
        },
      ],
      text: {
		'en': `As Holly and other advocates begin to organize, they elicit a response from their targets.`,
		'es': 'Cuando Holly y otros defensores comienzan a organizarse, obtienen una respuesta de sus destinatarios.'
	  }
    };
    const text = {
		'en': "With MHAction’s help, Holly and neighbors begin to demand action from the Federal Housing Finance Agency, members of Congress, and Bellweather Enterprise.",
		'es': 'Con la ayuda de MHAction, Holly y los vecinos comienzan a exigir la acción de la Agencia Federal de Financiamiento de la Vivienda, los miembros del Congreso y Bellweather Enterprise.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.marginTop == '10px') {
          self.helpers.pauseScrolling(1000);
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('.social'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.social {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 1100px;
  min-width: 1100px;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1600px) {
  .social {
    max-width: 900px;
    min-width: 900px;
  }
}

@media screen and (max-width: 1024px) {
  .social {
    max-width: 800px;
    min-width: 800px;
  }
}

@media screen and (max-width: 650px) {
  .social {
    max-width: 500px;
    min-width: 500px;
  }
}
</style>
